import { getUserAbridged } from "@/Services/DashboardOrchService";
import type { UserAbridged } from "@/types/AbridgedResponse";
import { isUserLoggedIn, readCookie, PerquisiteBountyEnable } from "@/utils/helper";

export interface UserPaidStatus {
  isUserPaid: boolean;
  isLoggedIn: boolean;
}

/** Matches download/export premium checks in musicExport.ts. */
export async function resolveUserPremiumFromAbridged(
  user: UserAbridged,
): Promise<boolean> {
  if (user.isPremiumUser || user.parentUserGuid) {
    return true;
  }

  if (user.perquisiteBountyKey && user.userGuid) {
    return PerquisiteBountyEnable(user.perquisiteBountyKey, user.userGuid);
  }

  return false;
}

/** Resolves whether the current user can bypass operation limits. */
export async function resolveUserPaidStatus(): Promise<UserPaidStatus> {
  const isLoggedIn = isUserLoggedIn();
  if (!isLoggedIn) {
    return { isUserPaid: false, isLoggedIn: false };
  }

  const jwtToken = readCookie("jwtToken");
  if (!jwtToken) {
    return { isUserPaid: false, isLoggedIn: true };
  }

  try {
    const abridgedResponse = await getUserAbridged();
    const isUserPaid = await resolveUserPremiumFromAbridged(abridgedResponse);
    return {
      isUserPaid,
      isLoggedIn: true,
    };
  } catch (error) {
    console.warn("Failed to resolve user paid status from abridged profile:", error);
    return { isUserPaid: false, isLoggedIn: true };
  }
}
